import React from "react";
import Button from "./buttons/Button";
import { NavLink } from "react-router-dom";

export default function Hero() {
  return (
    <div className="hero">
      <div className="hero_container">
        <div className="hero_desc">
          <h1>Free Sport Predictions & Betting Tips</h1>
          <p>
            PayoutProphet will provide free sport predictions, betting tips, form,
            statistics and tables for over 200 football leagues as well as over
            50 Tennis Tournaments with more to follow..
          </p>

          <div className="hero_btns">
            <NavLink to={"/signup"}>
              <Button value="Join Now" className={"btn btn_white"} />
            </NavLink>
            <NavLink to={"/predictions/expert"}>
              <Button value="Expert Tips" className={"btn"} />
            </NavLink>
          </div>
        </div>
        <img
          className="hero_image"
          src="images\banner-thumb-1.png"
          alt="hero"
        />
      </div>

      {/* <div className="navigations">
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          // spaceBetween={50}
          slidesPerView={3}
          scrollbar={{ draggable: true }}
        >
          <SwiperSlide>
            <Button value="Daily Two Odds" />
          </SwiperSlide>
          <SwiperSlide>
            <Button value="Expert Tips" />
          </SwiperSlide>
          <SwiperSlide>
            <Button value="Daily Free Odds" />
          </SwiperSlide>
          <SwiperSlide>
            <Button value="Rollover" />
          </SwiperSlide>

        </Swiper>
      </div> */}
    </div>
  );
}
